<template>
  <div>
    <AppHeader @refreshPage="init" />
    <div class="container">
      <div class="page-header">
        <div class="page-title">
          {{ $t('income') }}
        </div>
      </div>
      <div class="list1">
        <div class="item">
          <div class="text" :class="'text0'">
            <div class="label up">{{ $t('web5token') }}</div>
            <div class="value">{{ $handleNum(info.web5_score_total) }}</div>
          </div>
        </div>
        <div class="item">
          <div class="text" :class="'text1'">
            <div class="label up">{{ $t('krazetoken') }}</div>
            <div class="value">{{ $handleNum(info.kraze_token_total) }}</div>
          </div>
        </div>
      </div>
      <div class="page-title" style="margin-bottom: 0.2rem">
        {{ $t('incomepage.text1') }}
      </div>
      <div class="list1">
        <div
          class="item arrow"
          v-for="(item, index) in babeList"
          :key="index"
          @click="handleRoute('/mcn/bdetail', item)">
          <div class="flexable">
            <div
              class="avatar"
              :style="{
                backgroundImage:
                  'url(' + $store.state.imgUrl + item.avatar + ')'
              }"></div>
            <div class="babe-info">
              <div class="name">{{ item.name }}</div>
              <div class="des">{{ item.profile }}</div>
            </div>
          </div>
          <div class="flexable total-box">
            <div class="total">
              <b>{{ item.web5_score_total }}</b
              ><br />
              {{ $t('web5token') }}
            </div>
            <div class="total">
              <b>{{ item.kraze_token_total }}</b
              ><br />
              {{ $t('krazetoken') }}
            </div>
            <div class="total">
              <b>{{ item.nft_count }}</b
              ><br />
              {{ $t('nfts') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { postMcnBabeIncome, postMcnBabeList } from '@/api/mcn'

export default {
  name: 'McnIncome',
  components: {},
  data() {
    return {
      popupVisible: false,
      modelForm: {},
      info: {},
      babeList: []
    }
  },
  watch: {
    popupVisible: {
      handler(n) {
        this.$stopScroll(n)
      },
      deep: true
    },
    '$i18n.locale'() {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      postMcnBabeIncome().then((res) => {
        this.info = res.data
      })
      postMcnBabeList().then((res) => {
        this.babeList = res.data.lists
      })
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({
          path: path,
          query: { babe_user_id: item.id }
        })
      } else {
        this.$router.push({ path: path })
      }
    },
    handleInvite() {
      this.popupVisible = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/mcn/income.vue